export default __webpack_public_path__ + "static/logo-white@2x-cbd3c24b4316437481997f7a8efe2304.png";